<template>
  <div class="prepaid deduction-page">
    <job-header-simple
      header_title="专项附加扣除"
      v-if="showHeader"
    ></job-header-simple>
    <div class="card_box">
      <van-cell-group>
        <van-cell
          :value="`${childrenCount}人，${formatAmount(childrenCount * 2000)}元`"
          is-link
          @click="ChildrenEducationPopup('childrenCount')"
        >
          <template #title>
            <div class="custom-title">
              <img src="@/assets/images/education.png" />
              <span>子女教育</span>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="`${babyCount}人，${formatAmount(babyCount * 2000)}元`"
          is-link
          @click="ChildrenEducationPopup('babyCount')"
        >
          <template #title>
            <div class="custom-title">
              <img src="@/assets/images/child.png" />
              <span>3岁以下婴幼儿照护</span>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="`${formatAmount(elderlyCount)}元`"
          is-link
          @click="ChildrenEducationPopup('elderlyCount')"
        >
          <template #title>
            <div class="custom-title">
              <img src="@/assets/images/oldman.png" />
              <span>赡养老人</span>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="
            rental === 0
              ? `租金，${formatAmount(1500)}元`
              : rental === 1
              ? `租金，${formatAmount(1100)}元`
              : rental === 2
              ? `租金，${formatAmount(800)}元`
              : rental === 3
              ? `贷款，${formatAmount(1000)}元`
              : ''
          "
          is-link
          @click="ChildrenEducationPopup('Housing')"
        >
          <template #title>
            <div class="custom-title">
              <img src="@/assets/images/housing.png" />
              <span>住房贷款利息/租金</span>
            </div>
          </template>
        </van-cell>
        <van-cell
          class="custom-cell"
          :value="`${formatAmount(5000)}元`"
          is-link
        >
          <template #title>
            <div class="custom-title">
              <img src="@/assets/images/fixed.png" />
              <span>固定减除费用</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>

      <!-- 合计金额 -->
      <div class="total-section">
        <div class="total-label">扣除费用合计</div>
        <div class="total-amount">{{ formatAmount(totalDeduction) }}元/月</div>
      </div>
    </div>
    <div class="card_box">
      <!-- 填写须知 -->
      <div class="notice-section">
        <div class="notice-title">填写须知</div>
        <div class="notice-content">
          <p>
            1.请<span style="color: red;">参考</span>您在<span
              style="color: red;"
              >"个人所得税"APP</span
            >-专项附加扣除内容填写,本平台服务商将按您填写的专项附加扣除费用进行扣减后计算预缴税额。
          </p>
          <p>2.本平台暂不收录按年专项扣除,如继续教育、大病医疗项。</p>
          <p>
            3.各服务商(税源地)依据的当地税收政策实行预扣预缴，扣除项计算略有差异，详情请查看"基本信息"-服务商个税预缴扣除项。
          </p>
          <p>
            4.预扣预缴仅是本平台的分期缴纳,并非最终纳税金额;汇算清缴是纳税人年度结束后,有国家税务局汇总全年收入、扣除项后计算实际应纳税额,<span
              style="color: red;"
              >多退少补</span
            >,<span style="color: red;">个税以"个人所得税"APP计算为准</span>。
          </p>
          <p>
            5.依法纳税是每个公民应尽义务,您可登录国家税务总局官方应用--"个人所得税"APP,进行年度汇算等纳税申报。
          </p>
        </div>
      </div>
    </div>

    <!-- 子女教育弹窗 -->
    <van-popup
      v-model="showchildrenCount"
      position="bottom"
      round
      :style="{ height: 'auto' }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>子女数量</span>
          <span class="close-btn" @click="showchildrenCount = false">X</span>
        </div>
        <div class="popup-body">
          <van-form
            label-align="right"
            label-width="84px"
            ref="form"
            validate-first
            @failed="onFailed"
          >
            <!-- 通过 pattern 进行正则校验 -->
            <van-field
              label="子女数量"
              v-model="popupForm.childrenCount"
              name="pattern"
              placeholder="请输入子女数量"
              :rules="[{ pattern, message: '请输入正确的整数' }]"
            />
            <van-field label="扣除标准">
              <template #input>
                2000元/月
              </template>
            </van-field>
          </van-form>
        </div>
        <div class="popup-footer">
          <van-button color="#797979" size="normal" plain @click="deleteOtp"
            >删除</van-button
          >
          <van-button color="#169BD5" size="normal" @click="saveOtp"
            >保存</van-button
          >
        </div>
      </div>
    </van-popup>

    <!-- 3岁以下婴幼儿照护弹窗 -->
    <van-popup
      v-model="showbabyCount"
      position="bottom"
      round
      :style="{ height: 'auto' }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>3岁以下婴幼儿照护</span>
          <span class="close-btn" @click="showbabyCount = false">X</span>
        </div>
        <div class="popup-body">
          <van-form
            label-align="right"
            label-width="84px"
            ref="form"
            validate-first
            @failed="onFailed"
          >
            <!-- 通过 pattern 进行正则校验 -->
            <van-field
              label="婴幼儿数量"
              v-model="popupForm.babyCount"
              name="pattern"
              placeholder="请输入婴幼儿数量"
              :rules="[{ pattern, message: '请输入正确的整数' }]"
            />
            <van-field label="扣除标准">
              <template #input>
                2000元/月
              </template>
            </van-field>
          </van-form>
        </div>
        <div class="popup-footer">
          <van-button color="#797979" size="normal" plain @click="deleteOtp"
            >删除</van-button
          >
          <van-button color="#169BD5" size="normal" @click="saveOtp"
            >保存</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 赡养老人弹窗 -->
    <van-popup
      v-model="showelderlyCount"
      position="bottom"
      round
      :style="{ height: 'auto' }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span> 赡养老人</span>
          <span class="close-btn" @click="showelderlyCount = false">X</span>
        </div>
        <div class="popup-body">
          <van-form
            label-align="right"
            label-width="96px"
            ref="form"
            validate-first
            @failed="onFailed"
          >
            <!-- 通过 pattern 进行正则校验 -->
            <van-field
              label="月度扣除金额"
              v-model="popupForm.elderlyCount"
              name="pattern"
              placeholder="请输入月度扣除金额"
              :rules="[
                {
                  validator: validateElderlyAmount,
                  message: '请输入0-6000之间的整数',
                },
              ]"
            />
          </van-form>
          <p class="tip">
            统一按标准定额扣除： <br />
            1.被赡养人须年满60周岁<br />
            2.纳税人为独生子女，按3000元/月扣除额度<br />
            3.纳税人为非独生子女，由其与兄弟姐妹分摊每月3000元的扣除额度，每人分摊额度≤1500元/月
          </p>
        </div>
        <div class="popup-footer">
          <van-button color="#797979" size="normal" plain @click="deleteOtp"
            >删除</van-button
          >
          <van-button color="#169BD5" size="normal" @click="saveOtp"
            >保存</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 住房贷款利息/租金弹窗 -->
    <van-popup
      v-model="showHousing"
      position="bottom"
      round
      :style="{ height: 'auto' }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span> 住房贷款利息/租金</span>
          <span class="close-btn" @click="showHousing = false">X</span>
        </div>
        <div class="popup-body">
          <van-form
            label-align="right"
            label-width="84px"
            ref="form"
            validate-first
            @failed="onFailed"
          >
            <van-field
              readonly
              clickable
              name="picker"
              :value="housingType.text"
              label="请选择"
              placeholder="点击请选择"
              @click="showPickerChange('housingType')"
            />
            <van-field
              v-if="housingType.value === 3"
              readonly
              clickable
              name="picker"
              :value="areasObj.text"
              label="租房地区"
              placeholder="点击请选择"
              @click="showPickerChange('areasObj')"
            />
            <van-field label="扣除标准">
              <template #input> {{ deductionStandard }}元/月 </template>
            </van-field>
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                :default-index="defaultIndex"
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
          </van-form>
        </div>
        <div class="popup-footer">
          <van-button color="#797979" size="normal" plain @click="deleteOtp"
            >删除</van-button
          >
          <van-button color="#169BD5" size="normal" @click="saveOtp"
            >保存</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  NavBar,
  Cell,
  CellGroup,
  Popup,
  Form,
  Button,
  Field,
  Picker,
} from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import {
  saveSpecialDeduction,
  getSpecialAdditionalDeduction,
  updateSpecialDeduction,
  delSpecialDeduction,
} from '@/api/ocompany/request'
import { mapGetters } from 'vuex'
export default {
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Button.name]: Button,
    jobHeaderSimple,
  },
  created() {
    if (this.$route.query.hidetitle === 'true') {
      this.showHeader = false
    }
    this.init()
  },
  computed: {
    totalDeduction() {
      let total = 0
      switch (this.rental) {
        case 0:
          total = 1500
          break
        case 1:
          total = 1100
          break
        case 2:
          total = 800
          break
        case 3:
          total = 1000
          break
        default:
          break
      }
      // 计算总扣除金额
      return (
        this.childrenCount * 2000 + // 子女教育
        this.babyCount * 2000 + // 婴幼儿照护
        this.elderlyCount + // 赡养老人
        total + // 住房租金
        5000 // 固定减除
      )
    },
    ...mapGetters(['userInfo']),
  },
  data() {
    return {
      dataId: {
        childrenCountId: '',
        babyCountId: '',
        elderlyCountId: '',
        HousingId: '',
      }, //编辑的情况需要传id
      showHeader: true,
      rental: '', //租房 3贷款 0 直辖市住房 1 大于100万租房 2 小于100万租房
      childrenCount: 0, // 子女教育人数
      babyCount: 0, // 3岁以下婴幼儿照护人数
      elderlyCount: 0, // 赡养老人人数
      showchildrenCount: false, // 控制子女教育弹窗显示
      showbabyCount: false, // 控制3岁以下婴幼儿照护人数弹窗显示
      showelderlyCount: false, // 控制赡养老人人数弹窗显示
      showHousing: false, //住房租金弹窗
      popupForm: {
        childrenCount: 0, // 子女教育人数
        babyCount: 0, // 3岁以下婴幼儿照护人数
        elderlyCount: 0, // 赡养老人人数
      },
      popupType: '',
      pattern: /^(0|[1-9]\d*)$/,
      housingType: {
        text: '',
        value: '',
      },
      areasObj: {
        text: '',
        value: '',
      },
      columns: [],
      housingTypeColumns: [
        { value: 2, text: '住房贷款利息' },
        { value: 3, text: '住房租金' },
      ],
      areasObjColumns: [
        { value: 0, text: '直辖市、省会城市' },
        { value: 1, text: '人口超过100万的城市' },
        { value: 2, text: '人口低于100万的城市' },
      ],
      showPicker: false,
      deductionStandard: 1500,
      defaultIndex: 0,
      selectType: '', //选择类型   住房类型 还是租房地区
    }
  },
  methods: {
    init() {
      getSpecialAdditionalDeduction({
        employeeAccountId: this.userInfo.id,
      }).then((res) => {
        if (res.status === 200) {
          let data = res.data.data
          if (data && data.length > 0) {
            data.forEach((item) => {
              let deductionType = parseInt(item.deductionType)

              // 扣除类型：0子女教育,1继续教育,2住房贷款,3住房租金,4赡养老人,5婴幼儿照护,6大病医疗
              if (deductionType === 0) {
                if (item.childCount && item.childCount > 0) {
                  this.childrenCount = item.childCount
                  this.dataId.childrenCountId = item.id
                }
              }
              if (deductionType === 2) {
                this.rental = 3
                this.housingType.value = 2
                this.housingType.text = '住房贷款利息'
                this.dataId.HousingId = item.id
              }
              if (deductionType === 3) {
                this.housingType.value = 3
                this.housingType.text = '住房租金'
                this.rental = item.cityLevel
                this.dataId.HousingId = item.id
              }
              if (deductionType === 4) {
                this.elderlyCount = item.monthlyAmount
                this.dataId.elderlyCountId = item.id
              }
              if (deductionType === 5) {
                this.babyCount = item.childCount
                this.dataId.babyCountId = item.id
              }
            })
          }
        }
      })
    },
    //选择住房贷款类型 租房类型
    showPickerChange(type) {
      this.showPicker = true
      this.selectType = type
      this.columns = this[this.selectType + 'Columns']
      this.defaultIndex = this[this.selectType].text
        ? this.columns.findIndex(
            (item) => item.text === this[this.selectType].text
          )
        : 0
    },
    //住房、租房下拉框
    onConfirm(value) {
      this[this.selectType].text = value.text
      this[this.selectType].value = value.value
      if (this[this.selectType].value === 3) {
        if (!(this.areasObj.value && this.areasObj.value != '')) {
          this.areasObj.value = 0
          this.areasObj.text = '直辖市、省会城市'
        }
      }
      this.showPicker = false
      this.computingCosts()
    },
    computingCosts() {
      if (this.housingType.value === 2) {
        this.deductionStandard = 1000
      } else {
        if (this.areasObj.value === 0) {
          this.deductionStandard = 1500
        } else if (this.areasObj.value === 1) {
          this.deductionStandard = 1100
        } else {
          this.deductionStandard = 800
        }
      }
    },
    validateElderlyAmount(val) {
      const num = parseInt(val)
      return !isNaN(num) && num >= 0 && num <= 6000
    },
    ChildrenEducationPopup(type) {
      this.popupType = type
      this['show' + type] = true
      if (type === 'Housing') {
        //住房贷款 和租房特殊处理
        if (this.rental === 3) {
          this.housingType.value = 2
          this.housingType.text = '住房贷款利息'
        } else if (this.rental !== '') {
          this.housingType.value = 3
          this.housingType.text = '住房租金'
          this.areasObj.value = this.rental
          switch (this.areasObj.value) {
            case 0:
              this.areasObj.text = '直辖市、省会城市'
              break
            case 1:
              this.areasObj.text = '人口超过100万的城市'
              break
            case 2:
              this.areasObj.text = '人口低于100万的城市'
              break
          }
        } else {
          this.housingType.value = 3
          this.housingType.text = '住房租金'
          this.areasObj.value = 0
          this.areasObj.text = '直辖市、省会城市'
        }
        this.computingCosts()
      } else {
        this.popupForm[type] = this[type]
      }
    },
    onFailed(errorInfo) {},
    formatAmount(amount) {
      // 格式化金额显示
      return amount.toFixed(2)
    },
    async saveOtp() {
      // 获取表单实例
      const form = this.$refs.form

      if (!form) {
        return
      }

      // 进行表单校验
      try {
        await form.validate()
        let deductionType = ''
        let formArr = {
          childrenCount: 0,
          babyCount: 5,
          elderlyCount: 4,
        }

        let param = {
          employeeAccountId: this.userInfo.id,
        }
        // 表单校验通过，执行保存逻辑
        this['show' + this.popupType] = false
        if (this.popupType === 'Housing') {
          deductionType = this.housingType.value
          if (this.housingType.value === 2) {
            this.rental = 3
          } else if (this.housingType.value === 3) {
            if (this.areasObj.value !== '') {
              this.rental = this.areasObj.value
              param.cityLevel = this.rental
            }
          }
        } else {
          deductionType = formArr[this.popupType]
          if (this.popupType === 'elderlyCount') {
            param.monthlyAmount = parseInt(this.popupForm[this.popupType])
          } else {
            param.childCount = parseInt(this.popupForm[this.popupType])
          }

          this[this.popupType] = parseInt(this.popupForm[this.popupType])
        }
        param.deductionType = deductionType
        if (this.dataId[this.popupType + 'Id']) {
          param.id = this.dataId[this.popupType + 'Id']
          updateSpecialDeduction(param).then((res) => {
            console.log(res)
          })
        } else {
          saveSpecialDeduction(param).then((res) => {
            if (res.status == 200) {
              this.dataId[this.popupType + 'Id'] = res.data.data
            }
          })
        }

        // 这里可以添加保存逻辑，例如更新状态或发送请求
      } catch (error) {
        // 表单校验未通过，不执行保存逻辑
      }
    },
    deleteOtp() {
      // 删除子女教育信息
      this[this.popupType] = 0
      this['show' + this.popupType] = false
      if (this.popupType === 'Housing') {
        this.rental = ''
      }
      // 这里可以添加删除逻辑，例如更新状态或发送请求
      if (this.dataId[this.popupType + 'Id']) {
        delSpecialDeduction(this.dataId[this.popupType + 'Id']).then((res) => {
          if (res.status == 200) {
            this.dataId[this.popupType + 'Id'] = ''
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.card_box {
  padding: 10px 0;
  margin: 8px 12px;
  background: #fff;
  border-radius: 6px;
}
.deduction-page {
  .custom-title {
    display: flex;
    color: #333;
    align-items: center;
    white-space: nowrap;
    img {
      width: 24px;
      margin-right: 4px;
    }
  }
}
.van-cell-group {
  padding: 0 10px;
  .van-cell__value {
    color: #333;
  }
}
.van-cell-group::after {
  border-top: none;
}
.van-cell {
  padding: 10px 0;
  &.custom-cell {
    .van-cell__right-icon {
      color: #fff;
    }
  }
}

.total-section {
  display: flex;
  justify-content: space-between;
  padding: 15px 28px 15px 58px;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}

.notice-section {
  padding: 0 10px;
}

.notice-title {
  font-weight: bold;
  font-size: 14px;
  margin: 10px 0;
}

.notice-content {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}

.notice-content p {
  margin-bottom: 8px;
}
.popup-content {
  font-size: 14px;
  padding: 10px;
  .popup-header {
    font-size: 16px;
    position: relative;
    text-align: center;
    .close-btn {
      cursor: pointer;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid #666;
      line-height: 24px;
      text-align: center;
      position: absolute;
      right: 0;
    }
  }
  .popup-body {
    margin: 10px 0;
    /deep/.van-field__body input {
      border: 1px solid #aaa;
      padding: 4px 8px;
    }
    .tip {
      color: #666;
      margin-bottom: 10px;
    }
  }
  .popup-footer {
    display: flex;
    justify-content: center;
    .van-button {
      width: 110px;
      height: 40px;
      border-radius: 6px;
      &.van-button--plain {
        margin-right: 10px;
      }
    }
  }
}
</style>
